export * from "./vehicle-provenance-update.dto.interface";
